<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-joylearning__certinfo}">
      <el-form label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="queryCertList()">
        <el-row class="margb10">
          <!-- 认证名称 -->
          <el-col :span="7">
            <el-form-item :label="$t('cert.certName')">
              <el-input v-model="dataForm.certName"
                        clearable
                        :placeholder="$t('cert.plsInput')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 品牌 -->
          <el-col :span="7">
            <el-form-item :label="$t('cert.brand')"
                          prop="certBrand">
              <el-select v-model="dataForm.certBrand"
                         :placeholder="$t('cert.select')"
                         clearable>
                <el-option v-for="(item,index) in certBrandArrs"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 认证分类 -->
          <el-col :span="7">
            <el-form-item :label="$t('cert.certType')"
                          prop="certType">
              <el-select v-model="dataForm.certType"
                         :placeholder="$t('cert.select')"
                         clearable>
                <el-option v-for="(item,index) in certTypeArrs"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         v-if="$hasPermission('AUTHCERT0001')"
                         @click="queryCertList">{{$t('query')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="margb10">
          <!-- 认证级别 -->
          <el-col :span="7">
            <el-form-item :label="$t('cert.certLevel')" prop="certLevel">
              <el-select v-model="dataForm.certLevel"
                        :placeholder="$t('cert.selectTips')"
                        clearable>
                <el-option v-for="(item,index) in certLevelArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 认证状态 -->
          <el-col :span="7">
            <el-form-item :label="$t('cert.certStatus')" prop="certStatus">
              <el-select
                v-model="dataForm.certStatus"
                :placeholder="$t('cert.select')"
                clearable
              >
                <el-option
                  v-for="(item, index) in certStatusArrs"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 认证团队分类 -->
          <el-col :span="7">
            <div style="width: 100%; display: flex">
              <div style="width: 60%">
                <el-form-item
                  prop="certTeamCatalogFirst"
                  style="width: 100% !important"
                  :label="$t('cert.certTeamCatalog')"
                >
                  <div class="box01" style="width: auto; float: left">
                    <el-select
                      v-model="dataForm.certTeamCatalogFirst"
                      :placeholder="$t('cert.selectTips')"
                      @change="getcertTeamCatalog($event)"
                      clearable
                    >
                      <el-option
                        v-for="item in select1"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div
                style="width: 31%; margin-left: 3px"
                class="certTeamCatalogSecondSel"
              >
                <div class="box02" style="width: 60%; float: left">
                  <el-select
                    v-model="dataForm.certTeamCatalogSecond"
                    placeholder=" "
                    :loading="loading"
                    @change="getList($event)"
                    clearable
                  >
                    <el-option
                      v-for="item in select2"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </el-col>
          <!-- 重置 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button
                class="el-back M-search M-margin-l"
                type="info"
                v-if="$hasPermission('AUTHCERT0001')"
                @click="resetQuery"
                >{{ $t("reset") }}</el-button
              >
            </el-col>
          </el-col>
        </el-row>
        <!-- 高级搜索 --->
        <div v-show="isShow">
          <el-row class="margb10">
            <el-col :span="7">
              <el-form-item prop="courseCode">
                <span slot="label">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="addCourse"
                    >{{ $t("cert.selectCourse") }}</el-link
                  >
                </span>
                <el-input
                  v-model="dataFormHold.courseName"
                  clearable
                  disabled
                  @clear="celarCourseName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <!-- 课程分类 -->
              <el-form-item :label="$t('couse.coursecatalogid')">
                <catalogtree
                  @cateloglist="cateloglist"
                  :defaultProps="defaultPropsz"
                  :showArray="showCourseClassList"
                  :showValue="showValue"
                  :url="queryTreeUrl"
                  :isSelect="false"
                  :status="'classStatus'"
                  ref="catalogtree"
                ></catalogtree>
              </el-form-item>
            </el-col>
            <!-- 课程团队分类 -->
            <el-col :span="7">
              <div style="width: 100%; display: flex">
                <div style="width: 60%">
                  <el-form-item
                    prop="courseTeamCatalogFirst"
                    style="width: 100% !important"
                    :label="$t('cert.courseTeamCatalog2')"
                  >
                    <div class="box01" style="width: auto; float: left">
                      <el-select
                        v-model="dataForm.courseTeamCatalogFirst"
                        :placeholder="$t('cert.selectTips')"
                        @change="getcourseTeamCatalog($event)"
                        clearable
                      >
                        <el-option
                          v-for="item in select1"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <div
                  style="width: 31%; margin-left: 3px"
                  class="courseTeamCatalogSecondSel"
                >
                  <div class="box02" style="width: 60%; float: left">
                    <el-select
                      v-model="dataForm.courseTeamCatalogSecond"
                      placeholder=" "
                      :loading="loading"
                      @change="getList($event)"
                      clearable
                    >
                      <el-option
                        v-for="item in select3"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="margb10">
            <el-col :span="10">
              <el-form-item
                :label="$t('couse.createtime')"
                style="width: 100% !important"
              >
                <el-date-picker
                  v-model="dataFormHold.createtimeArr"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :start-placeholder="$t('couse.startdate1')"
                  :end-placeholder="$t('couse.endData1')"
                  :clearable="true"
                  @change="clearCreateTime"
                  style="width: 90%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="search">
        <el-button
          plain
          class="el-button-columnBtn"
          v-if="$hasPermission('AUTHCERT0003')"
          @click="addUpdate"
          >{{ $t("add") }}</el-button
        >
        <el-tooltip placement="top-start" effect="light">
          <div slot="content">{{ $t("cert.exportMsg") }}</div>
          <!-- 导出 -->
          <el-button
            plain
            class="el-button-columnBtn"
            v-if="$hasPermission('AUTHCERT0008')"
            @click="exportCert"
            >{{ $t("export") }}
            <em class="el-icon-question"></em>
          </el-button>
        </el-tooltip>
        <!-- 复制 -->
        <el-button
          plain
          class="el-button-columnBtn"
          v-if="$hasPermission('AUTHCERT0009')"
          @click="copyCert"
          >{{ $t("cert.copyCert") }}</el-button
        >
      </div>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        ref="selectCertinfo"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <!--序号-->
        <el-table-column
          :label="$t('couse.no')"
          type="index"
          :width="50"
          align="center"
          show-overflow-tooltip
          fixed
        >
          <template slot-scope="scope"
            ><span>{{ (page - 1) * limit + scope.$index + 1 }}</span></template
          >
        </el-table-column>
        <!--认证ID-->
        <el-table-column
          prop="certId"
          :label="$t('cert.certCode')"
          header-align="center"
          v-if="false"
          align="center"
          width="140"
        ></el-table-column>
        <!--认证编号-->
        <el-table-column
          prop="certCode"
          :label="$t('cert.certCode')"
          header-align="center"
          align="center"
          width="140"
          fixed
          show-overflow-tooltip
        ></el-table-column>
        <!--认证中文名称-->
        <el-table-column
          prop="certNameCn"
          :label="$t('cert.certNameCn')"
          header-align="center"
          align="center"
          width="150"
          fixed
          show-overflow-tooltip
        ></el-table-column>
        <!--认证英文名称-->
        <el-table-column
          prop="certNameEn"
          :label="$t('cert.certNameEn')"
          header-align="center"
          align="center"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <!--品牌-->
        <el-table-column
          prop="brandCodeLabel"
          :formatter="brandFormatter"
          header-align="center"
          align="center"
          :width="120"
          :label="$t('cert.brand')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--认证分类-->
        <el-table-column
          prop="certTypeLabel"
          :formatter="certTypeFormatter"
          header-align="center"
          align="center"
          :width="110"
          :label="$t('cert.certType')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--认证级别-->
        <el-table-column
          prop="certLevelLabel"
          :formatter="certLevelFormatter"
          header-align="center"
          align="center"
          :width="110"
          :label="$t('cert.certLevel')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--认证团队分类-->
        <el-table-column
          prop="certTeamCatalogLabel"
          :formatter="certTeamCatalogFormatter"
          header-align="center"
          align="center"
          :width="110"
          :label="$t('cert.certTeamCatalog')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--认证状态-->
        <el-table-column
          prop="certStatusLabel"
          :formatter="certStatusFormatter"
          header-align="center"
          align="center"
          :width="95"
          :label="$t('cert.certStatus')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--创建人-->
        <el-table-column
          prop="createUserNameCn"
          :label="$t('cert.createUserName')"
          header-align="center"
          align="center"
          width="110"
          show-overflow-tooltip
        ></el-table-column>
        <!--创建时间-->
        <el-table-column
          prop="createTimeStr"
          :label="$t('cert.createDate')"
          header-align="center"
          align="center"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <!--下架flg-->
        <el-table-column
          prop="undercarriageFlg"
          :label="$t('cert.certCode')"
          header-align="center"
          align="center"
          v-if="false"
          width="140"
        ></el-table-column>
        <!--操作 -->
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              <!-- 查看 -->
              <span
                class="el-dropdown-link"
                v-if="$hasPermission('AUTHCERT0002')"
                @click="showView(scope.row)"
                >{{ $t("view") }}</span
              >
              <div class="pkg-vertical-divider"></div>
              <el-dropdown trigger="click" placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t("cert.more")
                  }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!--编辑 -->
                  <el-dropdown-item
                    v-if="
                      (scope.row.certStatus == '10' ||
                        scope.row.certStatus == '20') &&
                      $hasPermission('AUTHCERT0004')
                    "
                    @click.native="update(scope.row)"
                    >{{ $t("cert.edit") }}</el-dropdown-item
                  >
                  <!--删除 -->
                  <el-dropdown-item
                    v-if="
                      scope.row.certStatus == '10' &&
                      $hasPermission('AUTHCERT0006')
                    "
                    @click.native="deleteCert(scope.row)"
                    >{{ $t("cert.delete") }}</el-dropdown-item
                  >
                  <!--下架 -->
                  <el-dropdown-item
                    v-if="
                      scope.row.certStatus == '20' &&
                      scope.row.undercarriageFlg == '1' &&
                      $hasPermission('AUTHCERT0005')
                    "
                    @click.native="undercarriage(scope.row)"
                    >{{ $t("cert.undercarriage") }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!--复制认证规则子画面-->
      <copyRule
        v-bind:visible="copyRuleDialog"
        v-bind:certIdList="certIdList"
        ref="copyRuleDialogRef"
        v-on:closeDialogCopyCert="closeDialogCopyCert"
      ></copyRule>
      <!-- 课程查询 -->
      <el-dialog
        :title="$t('offering.selectCourse')"
        :modal="false"
        width="90%"
        :visible.sync="dialogTableVisible"
        @close="closeFun"
      >
        <selCertCourse
          @inputss="inputss"
          ref="selCertCourseDialog"
          :courseInfoList="courseInfoList"
          :showModFlg="'2'"
        ></selCertCourse>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import catalogtree from "../common/catalogtree";
import ToggleDiv from "@/components/toggle-div";
import Vue from "vue";
import copyRule from "./copyRule";
import selCertCourse from "./selCertCourse";
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this;
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/learning/certinfo/queryCertList",
        getDataListIsPage: true,
        deleteURL: "/learning/certinfo/deleteCert",
      },
      dataList: [],
      // 品牌类型
      certBrandArrs: _this.enums["certBrand"],
      // 认证分类
      certTypeArrs: _this.enums["certType"],
      // 认证状态
      certStatusArrs: _this.enums["certStatus"],
      // 认证级别
      certLevelArr: _this.enums["certLevel"],
      courseInfoList: [],
      dataForm: {
        certName: "",
        certBrand: "",
        certType: "",
        certStatus: "",
        certLevel: "",
        certTeamCatalogFirst: "",
        certTeamCatalogSecond: "",
        courseTeamCatalogFirst: "",
        courseTeamCatalogSecond: "",
        courseCode: "",
        courseCatalogId: "",
        createtime: "",
        certNameExcel: "",
        certBrandExcel: "",
        certTypeExcel: "",
        certStatusExcel: "",
        certLevelExcel: "",
        certTeamCatalogFirstExcel: "",
        certTeamCatalogSecondExcel: "",
        courseTeamCatalogFirstExcel: "",
        courseTeamCatalogSecondExcel: "",
        courseCodeExcel: "",
        courseCatalogIdExcel: "",
        createtimeExcel: "",
        certTypeOptionsExcel: "",
        certTypeOptions:"",
        
      },
      dataFormHold: {
        certBrandArr: [],
        certTypeArr: [],
        certStatusArr: [],
        createtimeArr: [],
        courseName: "",
      },
      // 等待转圈
      dataListLoading: false,
      // 复制认证
      copyRuleDialog: false,
      isShow: false,
      // 认证IdList
      certIdList: [],
      dialogTableVisible: false,
      // 课程分类树
      defaultPropsz: {
        children: "children",
        label: "catalogNameCn",
        id: "catalogId",
      },
      showCourseClassList: [],
      showValue: "",
      queryTreeUrl: "/learning/coursecatalog/list",
      // 课程团队分类数据 Start
      select1: _this.enums["catalogidList1"],
      // [
      //   { value: '10', label: 'BBS-50' },
      //   { value: '20', label: 'BBS-51' },
      //   { value: '30', label: 'BBS-52' },
      //   { value: '40', label: 'BBS-53' },
      //   { value: '50', label: 'H5' },
      //   { value: '60', label: 'Non TA' }],
      loading: false,
      select2: [],
      select3: [],
      allteamcatalog: _this.enums["catalogidList2"],
      // [
      //   { pro: '10', label: '50' },
      //   { pro: '20', label: 'BP' }, { pro: '20', label: 'ME' }, { pro: '20', label: 'Others' },
      //   { pro: '30', label: 'MA' }, { pro: '30', label: 'S&M' }, { pro: '30', label: 'Others' },
      //   { pro: '40', label: 'Parts' }, { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
      //   { pro: '50', label: 'H5' },
      //   { pro: '60', label: 'CRM Coaching' }, { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' }
      // ]
      // 课程团队分类数据 End
    };
  },
  components: {
    catalogtree,
    ToggleDiv,
    copyRule,
    selCertCourse,
  },
  methods: {
    // 查询
    queryCertList() {
      this.page = 1;
      // if (this.dataFormHold.certBrandArr instanceof Array) {
      //   this.dataForm.certBrand = this.dataFormHold.certBrandArr.join(',')
      // }
      // if (this.dataFormHold.certTypeArr instanceof Array) {
      //   this.dataForm.certType = this.dataFormHold.certTypeArr.join(',')
      // }
      // if (this.dataFormHold.certStatusArr instanceof Array) {
      //   this.dataForm.certStatus = this.dataFormHold.certStatusArr.join(',')
      // }
      if (
        this.dataFormHold.createtimeArr instanceof Array &&
        this.dataFormHold.createtimeArr.length > 0
      ) {
        this.dataForm.createtime = this.dataFormHold.createtimeArr.join(",");
      } else {
        this.dataForm.createtime = "";
      }
      this.dataForm.certNameExcel = this.dataForm.certName;
      this.dataForm.certBrandExcel = this.dataForm.certBrand;
      this.dataForm.certTypeExcel = this.dataForm.certType;
      this.dataForm.certStatusExcel = this.dataForm.certStatus;
      this.dataForm.certLevelExcel = this.dataForm.certLevel;
      this.dataForm.certTeamCatalogFirstExcel =
        this.dataForm.certTeamCatalogFirst;
      this.dataForm.certTeamCatalogSecondExcel =
        this.dataForm.certTeamCatalogSecond;
      this.dataForm.courseTeamCatalogFirstExcel =
        this.dataForm.courseTeamCatalogFirst;
      this.dataFormcourseTeamCatalogSecondExcel =
        this.dataForm.courseTeamCatalogSecond;
      this.dataForm.courseCodeExcel = this.dataForm.courseCode;
      this.dataForm.courseCatalogIdExcel = this.dataForm.courseCatalogId;
      this.dataForm.createtimeExcel = this.dataForm.createtime;
      this.$refs.selectCertinfo.bodyWrapper.scrollLeft = 0;
      this.dataForm.certTypeOptionsExcel = this.dataForm.certTypeOptions;
      this.getDataList();
    },
    // 重置查询条件
    resetQuery() {
      this.dataForm = {
        certName: "",
        certBrand: "",
        certType: "",
        certStatus: "",
        certLevel: "",
        certTeamCatalogFirst: "",
        certTeamCatalogSecond: "",
        courseTeamCatalogFirst: "",
        courseTeamCatalogSecond: "",
        courseCode: "",
        courseCatalogId: "",
        createtime: "",
        certNameExcel: "",
        certBrandExcel: "",
        certTypeExcel: "",
        certStatusExcel: "",
        certLevelExcel: "",
        certTeamCatalogFirstExcel: "",
        certTeamCatalogSecondExcel: "",
        courseTeamCatalogFirstExcel: "",
        courseTeamCatalogSecondExcel: "",
        courseCodeExcel: "",
        courseCatalogIdExcel: "",
        createtimeExcel: "",
      };
      this.dataFormHold = {
        certBrandArr: [],
        certTypeArr: [],
        certStatusArr: [],
        createtimeArr: [],
        courseName: "",
      };
      this.showCourseClassList = [];
      this.courseInfoList = [];
      this.select2 = [];
      this.select3 = [];
      this.$refs.catalogtree.resetChecked();
      this.queryCertList();
    },
    addUpdate(row) {
      let name = "learning-cert-certAdd";
      let pkName = row != null ? row.certId : undefined;
      let query = {};
      query.certId = pkName;
      this.tabReplace(name);
      this.$router.push({
        name: name,
        query: query,
      });
      this.$eventHub.$emit("certAdd", "");
    },
    update(row) {
      let name = "learning-cert-certAdd";
      let query = {};
      query.certId = row.certId;
      this.tabReplace(name);
      this.$router.push({
        name: name,
        query: query,
      });
      this.$eventHub.$emit("certEdit", "");
    },
    showView(row) {
      let name = "learning-cert-certView";
      let query = {};
      query.certId = row.certId;
      this.tabReplace(name);
      this.$router.push({
        name: name,
        query: query,
      });
      this.$eventHub.$emit("certView", "");
    },
    deleteCert(row) {
      this.$confirm(
        this.$t("prompt.info", { handle: this.$t("delete") }),
        this.$t("prompt.title"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        }
      )
        .then(() => {
          this.$request
            .post(this.mixinViewModuleOptions.deleteURL, {
              certId: row.certId,
            })
            .then((res) => {
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getDataList();
                },
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    undercarriage(row) {
      this.$confirm(
        this.$t("prompt.info", { handle: this.$t("cert.undercarriage") }),
        this.$t("prompt.title"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        }
      )
        .then(() => {
          this.$request
            .post(`/learning/certinfo/undercarriage`, {
              certId: row.certId,
            })
            .then((res) => {
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getDataList();
                },
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 品牌转换
    brandFormatter(row) {
      return Vue.filter("coverEnum")(row.brandCode, "certBrand");
    },
    // 认证分类转换
    certTypeFormatter(row) {
      return Vue.filter("coverEnum")(row.certType, "certType");
    },
    // 认证状态转换
    certStatusFormatter(row) {
      return Vue.filter("coverEnum")(row.certStatus, "certStatus");
    },
    // 认证中文名称转换
    certNameFormatter(row) {
      return Vue.filter("coverEnum")(row.certNameCn, "certName");
    },
    // 认证级别转换
    certLevelFormatter(row) {
      return Vue.filter("coverEnum")(row.certLevel, "certLevel");
    },
    // 认证团队分类转换
    certTeamCatalogFormatter(row) {
      var nameFirst = Vue.filter("coverEnum")(
        row.courseTeamCatalogFirst,
        "catalogidList1"
      );
      var nameSecond = Vue.filter("coverEnum")(
        row.courseTeamCatalogSecond,
        "catalogidList2"
      );
      var comma = "";
      if (
        nameFirst !== null &&
        nameSecond !== null &&
        nameFirst !== "" &&
        nameSecond !== ""
      ) {
        comma = ",";
      }
      return nameFirst + comma + nameSecond;
    },
    // 复制认证规则
    copyCert() {
      let selectList = this.$refs.selectCertinfo.selection;
      let selectArr = [];
      if (selectList.length <= 0) {
        this.$message.warning(this.$t("cert.pleaseSelectCert"));
        return false;
      }
      for (var i in selectList) {
        selectArr.push(selectList[i].certId);
      }
      this.certIdList = selectArr;
      this.copyRuleDialog = true;
      // 调用复制规则弹出框的初始化方法
      this.$nextTick(() => {
        this.$refs.copyRuleDialogRef &&
          this.$refs.copyRuleDialogRef.initMethods();
      });
    },
    closeDialogCopyCert() {
      this.copyRuleDialog = false;
      // this.queryCertList()
    },
    // 认证信息导出
    exportCert() {
      let _this = this;
      let selectList = _this.$refs.selectCertinfo.selection;
      let selectArr = [];
      if (selectList.length > 0) {
        for (var i in selectList) {
          selectArr.push(selectList[i].certId);
        }
      }
      // download 参数 url, params, 报表名
      _this.$request.downloadByPost7(
        "/learning/certinfo/exportCertInfos",
        _this.$t("cert.excelCertInfo"),
        {
          certName: _this.dataForm.certNameExcel,
          certBrand: _this.dataForm.certBrandExcel,
          certType: _this.dataForm.certTypeExcel,
          certStatus: _this.dataForm.certStatusExcel,
          certLevel: _this.dataForm.certLevelExcel,
          certTeamCatalogFirst: _this.dataForm.certTeamCatalogFirstExcel,
          certTeamCatalogSecond: _this.dataForm.certTeamCatalogSecondExcel,
          courseTeamCatalogFirst: _this.dataForm.courseTeamCatalogFirstExcel,
          courseTeamCatalogSecond: _this.dataForm.courseTeamCatalogSecondExcel,
          courseCode: _this.dataForm.courseCodeExcel,
          courseCatalogId: _this.dataForm.courseCatalogIdExcel,
          createtime: _this.dataForm.createtimeExcel,
          certTypeOptions:_this.dataForm.certTypeOptionsExcel,
          certIds: selectArr.join(","),
        }
      );
    },
    // 认证团队分类二级菜单取得
    getcertTeamCatalog(prov) {
      let tempArry = [];
      this.select2 = [];
      if (
        this.dataForm.certTeamCatalogSecond !== null ||
        this.dataForm.certTeamCatalogSecond === ""
      ) {
        this.dataForm.certTeamCatalogSecond = "";
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2);
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code });
        }
        this.select2 = tempArry;
      }
    },
    // 课程团队分类二级菜单取得
    getcourseTeamCatalog(prov) {
      let tempArry = [];
      this.select3 = [];
      if (
        this.dataForm.courseTeamCatalogSecond !== null ||
        this.dataForm.courseTeamCatalogSecond === ""
      ) {
        this.dataForm.courseTeamCatalogSecond = "";
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2);
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code });
        }
        this.select3 = tempArry;
      }
    },
    getList(opt) {
      console.log(opt);
    },
    toggle(val) {
      this.isShow = val;
    },
    closeFun() {
      this.dialogTableVisible = false;
    },
    inputss: function (data) {
      let _this = this;
      _this.courseInfoList = [];
      data.forEach((row) => {
        _this.courseInfoList.push(row);
      });
      if (_this.courseInfoList && _this.courseInfoList.length > 0) {
        let courseName = [];
        let courseCode = [];
        _this.courseInfoList.forEach((row) => {
          courseName.push(row.courseNameCn);
          courseCode.push(row.courseCode);
        });
        this.dataFormHold.courseName = courseName.join(",");
        this.dataForm.courseCode = courseCode.join(",");
      } else {
        this.dataFormHold.courseName = "";
        this.dataForm.courseCode = "";
      }
      this.dialogTableVisible = false;
    },
    addCourse() {
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        this.$refs.selCertCourseDialog &&
          this.$refs.selCertCourseDialog.initMethods();
      });
    },
    celarCourseName() {
      this.courseInfoList = [];
    },
    // 课程分类调用树
    cateloglist: function (data) {
      let catalogIdArr = [];
      data[0].data.forEach((rows) => {
        catalogIdArr.push(rows.catalogId);
      });
      if (catalogIdArr && catalogIdArr.length > 0) {
        this.dataForm.courseCatalogId = catalogIdArr.join(",");
      } else {
        this.dataForm.courseCatalogId = "";
      }
    },
    // 删除要跳转的tab
    tabReplace(tabName) {
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
    },
    // 清空创建时间
    clearCreateTime() {
      this.dataForm.createtime = "";
    },
  },
};
</script>
<style scoped>
@import "../../../css/pkg-styles.css";
.el-date-editor.el-input {
  width: 150px;
}
.search {
  height: 50px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.certTeamCatalogSecondSel .el-form-item__content {
  margin-left: 5px !important;
}
.courseTeamCatalogSecondSel .el-form-item__content {
  margin-left: 5px !important;
}
</style>
